'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'poop';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f619';
var svgPathData = 'M209.2 9.9c2.5-6 8.3-9.9 14.8-9.9l8 0c71.6 0 131 52.2 142.1 120.7 29.5 14.2 49.9 44.4 49.9 79.3 0 7.2-.9 14.3-2.5 21.1 34.1 12.1 58.5 44.7 58.5 82.9 0 16-4.3 31-11.7 43.9 26.2 15.3 43.7 43.6 43.7 76.1 0 48.6-39.4 88-88 88L88 512c-48.6 0-88-39.4-88-88 0-32.5 17.6-60.8 43.7-76.1-7.5-12.9-11.7-27.9-11.7-43.9 0-38.3 24.4-70.8 58.5-82.9-1.7-6.8-2.5-13.8-2.5-21.1 0-48.6 39.4-88 88-88l18.7 0c20.6 0 37.3-16.7 37.3-37.3l0-8.9c0-12.3-4.9-24-13.5-32.7l-5.8-5.8c-4.6-4.6-5.9-11.5-3.5-17.4zM257.7 35c4.1 9.6 6.3 20.1 6.3 30.8l0 8.9c0 38.3-31 69.3-69.3 69.3L176 144c-30.9 0-56 25.1-56 56 0 9.1 2.2 17.7 6 25.2 2.4 4.7 2.3 10.2-.2 14.8s-7.1 7.7-12.3 8.3c-27.9 3.2-49.5 26.9-49.5 55.6 0 15.3 6.2 29.2 16.2 39.4 4 4 5.5 9.9 4.1 15.4S78.5 368.5 73 370c-23.7 6.5-41 28.3-41 54 0 30.9 25.1 56 56 56l336 0c30.9 0 56-25.1 56-56 0-25.7-17.4-47.4-41-54-5.5-1.5-9.7-5.8-11.2-11.3s.1-11.3 4.1-15.4c10-10.1 16.2-24 16.2-39.4 0-28.7-21.7-52.4-49.5-55.6-5.2-.6-9.8-3.7-12.3-8.3s-2.6-10.1-.2-14.8c3.8-7.6 6-16.1 6-25.2 0-24.5-15.8-45.4-37.8-53-5.9-2-10.1-7.4-10.7-13.6-4.5-48.3-39.7-87.6-85.8-98.4z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faPoop = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;